const CART_STORAGE_KEY = 'cart';

export const cartApi = {
  getCart() {
    const cartStr = localStorage.getItem(CART_STORAGE_KEY);
    if (!cartStr) return [];

    const rawData = JSON.parse(cartStr);

    // Migration: Convert old format to new format
    const migratedCart = rawData.map((item) => {
      // Check if item is in old format (product data directly stored)
      if (item.id && item.name && item.price && !item.product) {
        // Old format: convert to new format
        return {
          product: {
            id: item.id,
            name: item.name,
            description: item.description || '',
            price: item.price,
            originalPrice: item.originalPrice,
            imageUrl: item.imageUrl || '',
            category: item.category || 'Uncategorized',
            stock: item.stock || 10,
            colors: item.colors,
            sizes: item.sizes,
            brand: item.brand,
            material: item.material,
            tags: item.tags,
            customOptions: item.customOptions
          },
          quantity: item.quantity || 1,
          selectedSize: item.selectedSize
        };
      }

      // Already in correct format
      return item;
    });

    // Save migrated data back to localStorage (one-time migration)
    if (rawData.some((raw) => raw.id && !raw.product)) {
      this.saveCart(migratedCart);
    }

    return migratedCart;
  },

  saveCart(cart) {
    localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
    // Trigger custom event for real-time updates
    window.dispatchEvent(new CustomEvent('cartUpdated'));
  },

  addToCart(product, quantity = 1, isPackage = false) {
    const cart = this.getCart();

    // Check for existing item with same ID AND same variations/services
    // (items with different variations/services should be separate cart items)
    const existingItemIndex = cart.findIndex(item => {
      return item.product.id === product.id &&
             JSON.stringify(item.product.selectedVariations) === JSON.stringify(product.selectedVariations) &&
             JSON.stringify(item.product.selectedAdditionalServices) === JSON.stringify(product.selectedAdditionalServices);
    });

    if (existingItemIndex >= 0) {
      cart[existingItemIndex].quantity += quantity;
    } else {
      cart.push({ product, quantity, isPackage });
    }

    this.saveCart(cart);
    return cart;
  },

  updateQuantity(productId, quantity) {
    const cart = this.getCart();
    const itemIndex = cart.findIndex(item => item.product.id === productId);

    if (itemIndex >= 0) {
      if (quantity <= 0) {
        cart.splice(itemIndex, 1);
      } else {
        cart[itemIndex].quantity = quantity;
      }
    }

    this.saveCart(cart);
    return cart;
  },

  removeFromCart(productId) {
    const cart = this.getCart().filter(item => item.product.id !== productId);
    this.saveCart(cart);
    return cart;
  },

  clearCart() {
    localStorage.removeItem(CART_STORAGE_KEY);
  },

  getCartTotal() {
    const cart = this.getCart();
    return cart.reduce((total, item) => total + (item.product.price * item.quantity), 0);
  },

  getCartItemCount() {
    const cart = this.getCart();
    return cart.reduce((count, item) => count + item.quantity, 0);
  },

  // Alias for getCart to match old API
  getCartItems() {
    return this.getCart();
  },

  getPackagingTotal() {
    const cart = this.getCart();
    const packagingItems = cart.filter(item => item.isPackage === true);
    return packagingItems.reduce((total, item) => {
      const price = item?.product?.price || 0;
      return total + (price * (item?.quantity || 1));
    }, 0);
  },

  getPackagingItems() {
    const cart = this.getCart();
    return cart.filter(item => item.isPackage === true);
  },

  getNonPackagingItems() {
    const cart = this.getCart();
    return cart.filter(item => item.isPackage !== true);
  }
};
